import styled from 'styled-components';

let w = 760;
let wfull = w * 2 + 100 + 'px';
w += 'px';

export const Content = styled.div`
  position: absolute;
  left: 145px;
  top: -14px;
  border-radius: 12px;
`;

export const WrapperVideo = styled.div`
  width: ${wfull};
  display: flex;
  justify-content: center;
  & img {
    max-height: none;
  }
  & > * {
    width: ${w};
    margin: 0 40px;
    overflow: hidden;
  }
`;
export const VideoLink = styled.a`
  display: block;
  width: 60px;
  height: 49px;
  transition: 0.15s all ease-out;
  border-radius: 12px;
  background: #10151a
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='24' viewBox='0 0 48 36' fill='none'%3E%3Crect x='3' y='9' width='27' height='18' rx='4' stroke='%237a838a' stroke-width='2.4'/%3E%3Cpath d='M30 16.5 L43 10 v16 L30 19.5 Z' stroke='%237a838a' stroke-width='2.4' stroke-linejoin='round' stroke-linecap='round'/%3E%3C/svg%3E")
    no-repeat 50%;
  background-size: 32px auto;
  margin: 0 0 100px;
  cursor: pointer;
  border: 1px solid #2c353d;
  z-index: 99;
  position: relative;
  &:hover {
    background-color: #1a2429;
    border-color: #3d4952;
  }
  &.active {
    border-color: #47b972;
    background-color: #12171c;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='24' viewBox='0 0 48 36' fill='none'%3E%3Crect x='3' y='9' width='27' height='18' rx='4' stroke='%2347b972' stroke-width='2.4'/%3E%3Cpath d='M30 16.5 L43 10 v16 L30 19.5 Z' stroke='%2347b972' stroke-width='2.4' stroke-linejoin='round' stroke-linecap='round'/%3E%3C/svg%3E");
  }
  &.active:hover {
    background-color: #1a2429;
    border-color: #5cc98a;
  }
`;
